<template>
  <span class="dui-dropdown-option">
    <span
      class="content"
      :title="option.text"
      @click.stop.prevent="optionSelected"
    >
      <span class="text">
        {{ option.text }}
        <DuiIconTick class="icon-sm" />
      </span>
    </span>

    <DuiDropdownOption
      v-for="innerOption in getEnabledOptions()"
      :key="innerOption.idx"
      :class="{ 'option-label': innerOption.isLabel,
                'selected': innerOption.selected }"
      :multiple="multiple"
      :option="innerOption"
      @option-selected="innerOptionSelected"
    />
  </span>
</template>

<script>
function _hasSelectedChildren(option) {
  if (!option.options) {
    return false;
  }

  const directChildSelected = option.options.find(childOption => childOption.selected);
  if (directChildSelected) {
    return true;
  }

  const childrenLength = option.options.length;
  let i = 0;
  let indirectChildSelected = false;

  while (!indirectChildSelected && (i < childrenLength)) {
    indirectChildSelected = _hasSelectedChildren(option.options[i]);
    i++;
  }

  return indirectChildSelected;
}

export default {
  name: 'DuiDropdownOption',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    option: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getEnabledOptions() {
      if (!this.option.options) {
        return null;
      }

      return this.option.options.filter(option => option.enabled !== false);
    },
    innerOptionSelected(innerOption, state) {
      // Propagate child selected state
      this.$emit('option-selected', innerOption, state);

      if (!this.multiple) {
        return;
      }

      // This option is selected if any child is selected
      const hasSelectedChildren = _hasSelectedChildren(this.option);
      this.$emit('option-selected', this.option, hasSelectedChildren);
    },
    optionSelected() {
      this.$emit('option-selected', this.option, !this.option.selected);
    },
  },
};
</script>
